import { render, staticRenderFns } from "./BarraLateral.vue?vue&type=template&id=640e8d6a&"
import script from "./BarraLateral.vue?vue&type=script&lang=js&"
export * from "./BarraLateral.vue?vue&type=script&lang=js&"
import style0 from "./BarraLateral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports